import { render, staticRenderFns } from "./ShippingPaymentSection.vue?vue&type=template&id=8695effe&scoped=true&"
import script from "./ShippingPaymentSection.vue?vue&type=script&lang=js&"
export * from "./ShippingPaymentSection.vue?vue&type=script&lang=js&"
import style0 from "./ShippingPaymentSection.vue?vue&type=style&index=0&id=8695effe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8695effe",
  null
  
)

export default component.exports